import { PrimaryFocus } from '@/domain/primaryFocus/constant'

export const showLevelOfCareLink = (
  primaryFocus: PrimaryFocus,
  levelOfCare: string
): boolean => {
  if (levelOfCare === 'Co-Occurring Disorders') {
    return [
      PrimaryFocus.SUBSTANCE_USE,
      PrimaryFocus.MENTAL_HEALTH,
      PrimaryFocus.SUBSTANCE_USE_AND_MENTAL_HEALTH
    ].includes(primaryFocus)
  }
  return true
}
